import { ThemeProvider } from 'next-themes';
import { BrowserRouter } from 'react-router-dom';
import { Toaster } from 'sonner';
import { AiAssistantMount } from '@/components/ai/AiAssistantMount';
import { ChatMount } from '@/components/chat/ChatMount';
import { QueryProvider } from '@/components/providers/QueryProvider';
import { DocumentTitle } from '@/components/routing/DocumentTitle';
import { ScrollToTop } from '@/components/routing/ScrollToTop';
import { AiAssistantProvider } from '@/contexts/AiAssistantContext';
import { AuthProvider } from '@/contexts/AuthContext';
import { ChatWindowProvider } from '@/contexts/ChatWindowContext';
import { NoteWindowsProvider } from '@/contexts/NoteWindowsContext';
import { AfterFirstPaint } from '@/lib/useAfterFirstPaint';
import { NoteWindowsMount } from '@/pages/notes/components/window/NoteWindowsMount';
import { AppRoutes } from '@/routes/AppRoutes';
import '@/i18n';

export default function App() {
  return (
    <QueryProvider>
      <ThemeProvider attribute="class" defaultTheme="system" enableSystem>
        <AuthProvider>
          {/* Bottom centre: every side panel (SafePanel) opens on the right,
              and a top-right toast sat on its title and first field. */}
          <Toaster richColors position="bottom-center" />
          <BrowserRouter>
            <ScrollToTop />
            <DocumentTitle />
            {/* Above <Routes>, so open windows survive every navigation. */}
            <NoteWindowsProvider>
              <AiAssistantProvider>
                <ChatWindowProvider>
                  <AppRoutes />
                  {/* After the page has painted (lib/useAfterFirstPaint): none of
                      these is what the visitor came to see first. */}
                  <AfterFirstPaint>
                    <NoteWindowsMount />
                    {/* The assistant is global: same conversation over every app. */}
                    <AiAssistantMount />
                    {/* So is the chat: a reply never costs you the page. */}
                    <ChatMount />
                  </AfterFirstPaint>
                </ChatWindowProvider>
              </AiAssistantProvider>
            </NoteWindowsProvider>
          </BrowserRouter>
        </AuthProvider>
      </ThemeProvider>
    </QueryProvider>
  );
}
